import React, { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";

interface Campo {
  label: string;
  campo: string;
}

interface Props {
  campo: Campo[];
  onFiltrar: (filtro: { [key: string]: string }) => void;
  limparFiltro: () => void;
}

export default function Filtro({ campo, onFiltrar, limparFiltro }: Props) {
  const [campoSelecionado, setCampoSelecionado] = useState<string>("");
  const [valorDigitado, setValorDigitado] = useState<string>("");
  const [filtro, setFiltro] = useState<{ [key: string]: string }>({});
  const [filtroLimpo, setFiltroLimpo] = useState<boolean>(true);
  const [inputDesativado, setInputDesativado] = useState<boolean>(true);

  const gerenciarMudancaFiltro = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const opcaoSelecionada = event.target.value;
    setCampoSelecionado(opcaoSelecionada);
    setInputDesativado(opcaoSelecionada === ""); 
  };

  const atualizarTextoDigitado  = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setValorDigitado(event.target.value);
  };

  const executarFiltragem  = async () => {
    try {
      const novoFiltro = {
        [campoSelecionado]: valorDigitado,
      };
      setFiltro(novoFiltro);
      setFiltroLimpo(false);
      onFiltrar(novoFiltro);
    } catch (error) {
      console.error("Erro ao filtrar:", error);
    }
  };

  const limparFiltros  = () => {
    setCampoSelecionado("");
    setValorDigitado("");
    setFiltro({});
    setFiltroLimpo(true);
    limparFiltro();
  };

  return (
    <main className="mainContainer h-auto">
      <div className="container mt-3">
        <div className="row">
          <label className="col-12 col-sm-auto mt-1">Filtrar por:</label>
          <div className="col-12 col-sm-auto d-flex align-items-center">
            <select
              className="form-select mb-3 filtro-select"
              aria-label="Small select example"
              onChange={gerenciarMudancaFiltro}
              value={campoSelecionado}
            >
              <option value="">Selecione uma opção</option>
              {campo.map((opcao, index) => (
                <option key={index} value={opcao.campo}>
                  {opcao.label}
                </option>
              ))}
            </select>
          </div>
          <div className="col-12 col-sm-auto">
            <input
              className="form-control mb-2"
              list="datalistOptions"
              id="exampleDataList"
              placeholder="Pesquisar..."
              onChange={atualizarTextoDigitado }
              value={valorDigitado}
              disabled={inputDesativado}
            />
          </div>
          <div className="col-auto col-sm-auto ">
            <button
              type="button"
              role="button"
              style={{ width: "100px"}}
              className="btn btn-outline-primary me-2 btn-sm custom-btn"
              onClick={executarFiltragem }
            >
              Filtrar
            </button>
          </div>
          <div className="col-auto col-sm-auto">
            <button
              type="button"
              role="button"
              style={{ width: "100px"}}
              className="btn btn-outline-primary me-2 btn-sm custom-btn"
              onClick={limparFiltros }
            >
              Limpar
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}